export function parseLocalizedAmount(value: string | number | null | undefined): number | null {
  if (value === null || value === undefined) {
    return null;
  }
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return null;
  }

  const normalized = normalizeAmountString(trimmed.replace(/\s/g, ''));
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : null;
}

function normalizeAmountString(value: string): string {
  const lastComma = value.lastIndexOf(',');
  const lastDot = value.lastIndexOf('.');

  if (lastComma !== -1 && lastDot !== -1) {
    if (lastComma > lastDot) {
      return value.replace(/\./g, '').replace(',', '.');
    }
    return value.replace(/,/g, '');
  }

  if (lastComma !== -1) {
    return value.replace(/\./g, '').replace(',', '.');
  }

  if (lastDot !== -1) {
    const parts = value.split('.');
    if (parts.length > 2) {
      return parts.join('');
    }
    const fraction = parts[1] ?? '';
    if (fraction.length === 3 && (parts[0]?.length ?? 0) <= 3) {
      return parts.join('');
    }
    return value;
  }

  return value;
}
